module.exports = __webpack_public_path__ + "static/media/DASH.255d6b7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/components/CoinCircle/icons/DASH.svg
// module id = 1496
// module chunks = 85